function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 3,
  width: 24,
  height: 2,
  rx: 1,
  fill: "#000"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 12,
  width: 24,
  height: 2,
  rx: 1,
  fill: "#000"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 20,
  width: 24,
  height: 2,
  rx: 1,
  fill: "#000"
});
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgMenu;